export default __webpack_public_path__ + "static/media/EugeniaLovelace.551dbbde.png";